export const setCameraMode = (state, params) => {
	const { payload: cameraMode } = params;
	state.cameraMode = cameraMode;
	return state;
};

export default {};